import subscription from '@api/subscription'
import {
  SUBSCRIPTION_CHOOSE,
  SUBSCRIPTION_CLEAR,
} from './_types'

const getDefaultState = () => {
  return {
    chosenSubscriptionID: null,
  }
}

export const state = getDefaultState()

export const getters = {}

export const mutations = {
  [SUBSCRIPTION_CHOOSE](state, id) {
    if (name !== 'null') {
      state.chosenSubscriptionID = id
    } else {
      state.chosenSubscriptionID = null
    }
  },
  [SUBSCRIPTION_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  generateAuthenticationToken({ commit }, payload) {
    return subscription.generateAuthenticationToken(payload)
  },
  generateCheckoutSession({ commit }, payload) {
    return subscription.generateCheckoutSession(payload).then((response) => {
      return response.data
    }).catch(() => {
      // ToDo send as error log
      this.$message({
          type: 'error',
          message: 'Failed to load payment system',
        })
    })
  },
  generateCustomerPortalSession({ commit }, payload) {
    return subscription.generateCustomerPortalSession(payload)
      .then((response) => {
        return response.data
      })
      .catch(() => {
        // ToDo send as error log
        this.$message({
          type: 'error',
          message: 'Failed to load payment system',
        })
      })
  },
  voidCancellation({ commit }) {
    return subscription.voidCancellation()
  },
  setChosenSubscriptionID({ commit }, id) {
    commit(SUBSCRIPTION_CHOOSE, id)
  },
  clearSubscriptionStatus({ commit }) {
    commit(SUBSCRIPTION_CLEAR)
  },
}
